import { createBulkProcessTextRows } from '@components/process-invite-guest/utils/invite-guest-utils';

// Re-export the existing utility for centralized access
export { createBulkProcessTextRows };

// Common interface for bulk process form data
export interface BulkProcessFormData {
  offerId: string;
  channelId: string;
  eventId: string;
  addOns?: string[];
}

// Type for bulk process row data
export type BulkProcessRow = {
  row: number;
  fullName: string;
  numTickets: string | number;
  email: string | null;
};

// Process bulk process text and calculate totals
export const processBulkProcessText = (bulkText: string) => {
  const rows = createBulkProcessTextRows(bulkText);
  const totalQuantity = rows.reduce((acc: number, row: BulkProcessRow) => acc + Number(row.numTickets), 0);

  return {
    rows,
    totalQuantity,
  };
};

// Create standardized import data for bulk process operations
export const createImportDataForBulkProcess = (
  formData: BulkProcessFormData,
  rows: BulkProcessRow[],
  totalQuantity?: number
) => ({
  offerId: formData.offerId,
  channelId: formData.channelId,
  eventId: formData.eventId,
  rows,
  addOns: formData.addOns
    ? formData.addOns.map((addon) => ({
        id: addon,
        quantity: totalQuantity ?? rows.length,
      }))
    : [],
});

// Helper function for handling bulk process submissions
export const handleBulkProcessSubmission = (
  bulkText: string,
  formData: BulkProcessFormData,
  submitFn: (importData: { importData: ReturnType<typeof createImportDataForBulkProcess> }) => void
) => {
  const { rows, totalQuantity } = processBulkProcessText(bulkText);
  const importData = createImportDataForBulkProcess(formData, rows, totalQuantity);
  submitFn({ importData });
};
